<template>
  <section class="policy policy-returns">
    <div class="policy-card">
      <h2 class="policy-title">Zwroty</h2>

      <div class="policy-table">
        <div class="policy-row">
          <div class="policy-cell policy-label">Prawo do zwrotu</div>
          <div class="policy-cell policy-value">14 dni od otrzymania produktu</div>
        </div>

        <div class="policy-row">
          <div class="policy-cell policy-label">Zwracany produkt</div>
          <div class="policy-cell policy-value">
            Musi być w stanie nienaruszonym, nieużywany, kompletny oraz w oryginalnym opakowaniu
          </div>
        </div>

        <div class="policy-row">
          <div class="policy-cell policy-label">Koszt zwrotu</div>
          <div class="policy-cell policy-value">Pokrywa kupujący</div>
        </div>

        <div class="policy-row">
          <div class="policy-cell policy-label">Czas rozpatrzenia</div>
          <div class="policy-cell policy-value">Do 14 dni roboczych od doręczenia przesyłki</div>
        </div>

        <div class="policy-row">
          <div class="policy-cell policy-label">Wysyłka na własną rękę</div>
          <div class="policy-cell policy-value">
            Przed odesłaniem prosimy o kontakt — zwroty bez wcześniejszego zgłoszenia nie będą przyjmowane
          </div>
        </div>
      </div>

      <p class="policy-note">
        W wiadomości podaj numer zamówienia i zdjęcie produktu/opakowania. To przyspieszy proces.
      </p>
    </div>
  </section>
</template>